import React from 'react';
import { Typography } from '@material-ui/core';
import { Section, SmSpace } from 'm2m.components';
import { ParticipanteResponse } from 'common/genericTypes';

interface Props {
  informacoesBancarias: ParticipanteResponse;
}

export const ServicosFinanceiros: React.FC<Props> = ({ informacoesBancarias }) => {
  const { contaBancoLiquidante, ispbBancoLiquidante, agenciaBancoLiquidante } = informacoesBancarias;

  const renderInfo = (title: string, value: string | undefined | null) => {
    return (
      value && (
        <div>
          <Typography variant="body2">{title}</Typography>
          <Typography variant="body1">{value ?? value}</Typography>
          <SmSpace />
        </div>
      )
    );
  };

  return (
    <Section title={'Conta Laqus'} defaultGrid>
      {renderInfo('ISPB:', ispbBancoLiquidante)}
      {renderInfo('Agência:', agenciaBancoLiquidante)}
      {renderInfo('Conta:', contaBancoLiquidante)}
    </Section>
  );
};

export default ServicosFinanceiros;
